import {
  Box,
  Button,
  Flex,
  Heading,
  Stack,
  useColorModeValue
} from "@chakra-ui/react"
import * as React from "react"
import { useRecoilValue, useSetRecoilState } from "recoil"
import layoutStates from "../../../recoil/atoms/layout"
import { useTranslation } from "react-i18next"
import { brandingSelector } from "../../../recoil/atoms/room"
import { HiMagnifyingGlass } from "react-icons/hi2"
import { Conditional404Button } from "./Conditional404Button"

// const closeMe = () => {
//   setTimeout(() => window.open("", "_self")?.close(), 200)
//   //document.getElementsByTagName('html')[0].remove();
// }

export const NotFound = () => {
  const roomStyles = useRecoilValue(brandingSelector)
  const setShowHeader = useSetRecoilState(layoutStates.showHeader)
  const { t } = useTranslation()
  React.useEffect(() => {
    // Hider the header
    setShowHeader(false)
  }, [setShowHeader])

  return (
    <Flex
      // minH="calc(100vh - 64px)"
      minH="100vh"
      align={"center"}
      justify={"center"}
      bgColor={
        roomStyles?.roomBackgroundColor
          ? roomStyles.roomBackgroundColor
          : "gray.100"
      }
      bgImage={
        roomStyles?.roomBackgroundImage
          ? `url(${roomStyles.roomBackgroundImage})`
          : "none"
      }
      bgSize="cover"
      bgRepeat="no-repeat"
      pos="absolute"
      left="0"
      // top="64px"
      w="100%"
    >
      {/* <Stack spacing={8} mx={"auto"}  py={12} px={4} width="100%"> */}
      <Box
        rounded={"lg"}
        bg={useColorModeValue("white", "gray.800")}
        boxShadow={"lg"}
        py={8}
        px={8}
        w={["100%", 400]}
        my={4}
        mx={4}
        borderWidth="1px"
        borderColor="gray.200"
      >
        <Stack spacing={4}>
          <Stack align={"center"}>
            <Flex
              background="gray.100"
              borderRadius={50}
              padding={4}
              fontSize="24"
              color="gray.600"
            >
              <HiMagnifyingGlass />
            </Flex>
            <Heading fontSize={"4xl"} align={"center"}>
              {t("Room not found")}
            </Heading>
          </Stack>

          {/* <Center>
              <UserAvatar
                colorDisk=""
                src="https://livesell.co/assets/img/livesell_default_icon.png"
              />
            </Center> */}
          <Conditional404Button />
          {/*
            <Button
              bg="#ff0000"
              color={"white"}
              _hover={{
                bg: "red.600"
              }}
              onClick={closeMe}
            >
              Close
            </Button> */}
        </Stack>
      </Box>
      {/* </Stack> */}
    </Flex>
  )
}

export default NotFound
